module.exports = __webpack_public_path__ + "static/media/hero.4acf60cc.svg";